import { LegislationFilterValues } from "../ui/components/global";

type AppliedFilter = {
  id: string;
  values: string[];
};

const fieldMap: Record<keyof LegislationFilterValues, string> = {
  searchMode: "modo_busca",
  selectedCode: "codigo",
  codeArticle: "artigo",

  normType: "tipo_doc",
  agency: "orgao",
  number: "numero",
  article: "artigo",
};

const reverseFieldMap = Object.entries(fieldMap).reduce(
  (acc, [key, value]) => {
    acc[value] = key as keyof LegislationFilterValues;
    return acc;
  },
  {} as Record<string, keyof LegislationFilterValues>,
);

export function transformAppliedFiltersToLegislation(
  appliedFilters: AppliedFilter[],
): Partial<LegislationFilterValues> {
  console.log(appliedFilters);

  const result: Partial<LegislationFilterValues> = {};

  const searchMode = appliedFilters.find((f) => f.id === "modo_busca")
    ?.values[0];

  for (const filter of appliedFilters) {
    if (filter.id === "artigo") {
      if (searchMode === "detailed") {
        result.article = (filter.values[0] as any) || null;
      } else {
        result.codeArticle = (filter.values[0] as any) || null;
      }
      continue;
    }

    const key =
      reverseFieldMap[filter.id] ??
      (filter.id as keyof LegislationFilterValues);

    if (!key) continue;

    result[key] = filter.values[0] as any;
  }

  console.log(result);

  return result;
}

export function transformLegislationToAppliedFilters(
  filters: LegislationFilterValues,
): AppliedFilter[] {
  return Object.entries(filters)
    .filter(([_, value]) => {
      return value !== "" && value !== null;
    })
    .map(([key, value]) => ({
      id: fieldMap[key as keyof LegislationFilterValues] ?? key,
      values: [String(value)],
    }));
}
